import React from "react"
import DateFilterOptions from "@/pages/Admin/ClientCatalog/ClientManageFilters/ContactsFilters/components/DateFilterOptions"
import { ContactsFiltersConditions, DateFilterState } from "@/protocols/ClientCatalogFilterProtocol"

type ContactLastTransactedMessageDateFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_last_message_date">
	onChange: (condition: ContactsFiltersConditions<"contact_last_message_date">) => void
}

const ContactLastTransactedMessageDateFilterCondition: React.FC<ContactLastTransactedMessageDateFilterConditionProps> = ({
	condition,
	onChange
}) => {
	const handleChange = (options: DateFilterState) => {
		onChange({
			type: "contact_last_message_date",
			operator: options.operator,
			filterData: {
				dateFrom: options?.dateFrom,
				dateTo: options?.dateTo
			}
		})
	}

	return (
		<DateFilterOptions
			operator={condition.operator}
			onChange={handleChange}
			dateFrom={condition.filterData.dateFrom}
			dateTo={condition.filterData.dateTo}
		/>
	)
}
export default ContactLastTransactedMessageDateFilterCondition
